import { render, staticRenderFns } from "./WarehousesPost.vue?vue&type=template&id=715e412c&"
import script from "./WarehousesPost.vue?vue&type=script&lang=js&"
export * from "./WarehousesPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports